import React from 'react'

export default function Footer() {
  return (
    <div>
      <footer>
        <ul>
          <h1>Resources</h1>
          <li>Fees</li>
          <li>API</li>
          <li>VIP Program</li>
          <li>Ambassador Program</li>
          <li>STX Whitelabel</li>
          <li>Volume Monitor</li>
          <li>Leaderboard</li>
        </ul>
        <ul>
          <h1>Company</h1>
          <li>About</li>
          <li>Contact Us</li>
          <li>Policy</li>
          <li>Legal</li>
          <li>FTT</li>
          <li>FTX Blog</li>
          <li>FTX Climate</li>
        </ul>
        <ul>
          <h1>Support</h1>
          <li>Announcements</li>
          <li>Help Center</li>
          <li>File Support Ticket</li>
        </ul>
        <ul>
          <h1>Learn</h1>
          <li>Leveraged Tokens</li>
          <li>MOVE Contract</li>
          <li>Options</li>
          <li>Quant Zone</li>
        </ul>
        <ul>
          <h1>Partners</h1>
          <li>FTX International</li>
          <li>FTX US</li>
        </ul>
        <ul className='media'>
          <div className="logo">
            <i class="fa-solid fa-chart-simple"></i>
            <a  href="#">STX</a>
          </div>
          <div className="social">
            <i class="fa-brands fa-twitter fa-2x"></i>
            <i class="fa-brands fa-facebook-f fa-2x"></i>
            <i class="fa-brands fa-telegram fa-2x"></i>
            <i class="fa-brands fa-youtube fa-2x"></i>
          </div>
        </ul>
      </footer>
        <div className="disclaimer">
          <p>STX Services and STX Token (STT) are not available in the United States or other prohibited jurisdictions.</p>
          <p>Services for this product are facilitated through STX Trading Ltd and/or STX Digital Markets Ltd.</p>
        </div>      
    </div>
  )
}
